import React, { useEffect, useMemo, useState } from 'react';
import { Link, Head, useForm } from '@inertiajs/inertia-react';
import Input from '@/Components/Input';
import Button from '@/Components/Button';
import ApplicationLogo from '@/Components/ApplicationLogo';
import { DateTime } from 'luxon';
import { getRandomLastname, getRandomName, getRandomRut, showJSONData } from '@/helpers/example';
import rut from '@/helpers/rut';
import Label from '@/Components/Label';
import { getRandomBoolean } from '@/helpers/boolean';
import Form from '@/Components/UsersRegistration/Form';
import Cookies from 'js-cookie';
import { userIsValid, usersAreValid } from '@/helpers/user';
import useAssistants from '@/hooks/useAssistants';
import { useUsersRegistrationContext } from '@/context/UsersRegistration';
import { messagesPopUpYounger } from './Welcome';

export default function UsersRegistration({
    store,
    quantity,
    date,
    availability,
    office,
    schedule,
    scheduleType,
    uuid,
    ...props
}) {

    const {
        usersRegistration,
        handleChangeUsersRegistration,
        handleChangeResponsibleUser,
        responsibleUser,
        refreshDataUsersRegistration,
        selectAll,
        deselectAll,
        responsibleForAssistants,
        setResponsibleForAssistants
    } = useUsersRegistrationContext();

    const { data, processing, get, errors } = useForm({
        schedule: schedule?.id,
        quantity,
        uuid,
    });

    useEffect(() => {
        refreshDataUsersRegistration({quantity: parseInt(data.quantity)})
    }, [data.quantity])

    const [axiosErrors, setAxiosErrors] = useState({});

    const submit = (e) => {
        e.preventDefault();
        console.log('users are valid',usersAreValid(usersRegistration, quantity, responsibleForAssistants))
        console.log('user is valid', userIsValid(responsibleUser))
        if (usersAreValid(usersRegistration, quantity, responsibleForAssistants) && userIsValid(responsibleUser)) {
            get(route('order.create', {office: office, scheduleType: scheduleType, uuid}))
        }
    }

    useEffect(() => {
        Cookies.remove('order_checkout_clients');
    }, [])

    const handleAction = (action) => {
        switch(action){
            case 'SELECT_ALL':
                return selectAll();
            case 'DESELECT_ALL':
                return deselectAll();
        }
    }

    const removeError = (error) => {
        try {
            const filteredAxiosErrors = _.omit(axiosErrors, error);
            setAxiosErrors(filteredAxiosErrors);
        } catch (error) {}
    }

    return (
        <>
            <Head title="Selección de hora - Cerogrado" />
            <div className="relative flex items-start w-full justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">
                <div className="w-full max-w-7xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">
                    <div className="flex justify-center pt-8 sm:pt-0">
                        {/* <img src={logo} className="h-16 w-auto sm:h-20"/> */}
                        <ApplicationLogo store={store} />
                    </div>

                    <div className="max-w-2xl mx-auto">
                        <div className="w-full mx-auto mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg mb-2">
                            <h1 className='mb-4 text-center text-gray-900 text-lg font-bold'>Registro del responsable y asistentes</h1>
                            <p className="w-2/3 mx-auto text-center mb-10">Por favor lea el <a target="_blank" className="text-blue-500 underline" href="https://www.cerogrado.cl/wp-content/uploads/2023/04/Acuerdo-de-uso-CEROGRADO.pdf">Acuerdo de uso de las instalaciones</a> e ingrese a continuación a las personas que asistirán.</p>
                            {schedule && <p className='text-center'>{props.queryDescription} <br /> Entre las {DateTime.fromSQL(schedule.start_time).toFormat('HH:mm')} y las {DateTime.fromSQL(schedule.start_time).plus({ hours: scheduleType.duration }).toFormat('HH:mm')}.</p>}
                            <Link
                                href={route("schedule.search", {office: office.slug, scheduleType, uuid})}
                                as="button"
                                type="button"
                                className='flex items-center px-2 py-1 border border-gray-900 rounded-md font-semibold text-xs text-gray-900 hover:bg-gray-900 hover:text-white transition ease-in-out duration-150 mx-auto mt-3'
                                data={{ quantity, date: date }}>
                                Modificar
                            </Link>
                        </div>
                        <div className="w-full mx-auto px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg mb-2">
                            {messagesPopUpYounger[store]}
                        </div>
                        <div className="bg-white shadow-md overflow-hidden sm:rounded-lg px-3">

                            <div className="border rounded-xl p-5  my-5 relative ">
                                <h2 className="absolute bg-white px-2 font-bold" style={{top:'-13px'}}>Datos del responsable</h2>
                                <form>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
                                        <div>
                                            <Label forInput="first_name" value="Nombre" />
                                            <Input
                                                type="text"
                                                name="name"
                                                value={responsibleUser?.name}
                                                className="mt-1 block w-full"
                                                isFocused={true}
                                                required={true}
                                                handleChange={handleChangeResponsibleUser}
                                            />
                                            {/* <Error bind={errors.first_name || axiosErrors?.first_name} /> */}
                                        </div>
                                        <div>
                                            <Label forInput="second_name" value="Apellido" />
                                            <Input
                                                type="text"
                                                name="lastname"
                                                value={responsibleUser?.lastname}
                                                className="mt-1 block w-full"
                                                required={true}
                                                handleChange={handleChangeResponsibleUser}
                                            />
                                            {/* <Error bind={errors.second_name} /> */}
                                        </div>
                                        <div>
                                            <Label forInput="rut" value="R.U.N" />
                                            <Input
                                                type="text"
                                                name="rut"
                                                value={responsibleUser?.rut}
                                                className="mt-1 block w-full"
                                                required={true}
                                                handleChange={(event) => handleChangeResponsibleUser(event, {value: rut.format(event.target.value) === '-' ? '' : rut.format(event.target.value)})}
                                            />
                                            {/* <Error bind={errors.rut || axiosErrors?.rut} /> */}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                        <div>
                                            <Label forInput="first_name" value="Correo electrónico" />
                                            <Input
                                                type="email"
                                                name="email"
                                                value={responsibleUser?.email}
                                                className="mt-1 block w-full"
                                                isFocused={true}
                                                required={true}
                                                handleChange={handleChangeResponsibleUser}
                                            />
                                            {/* <Error bind={errors.first_name || axiosErrors?.first_name} /> */}
                                        </div>
                                        <div>
                                            <Label forInput="telephone" value="Número de teléfono" />
                                            <Input
                                                type="text"
                                                name="telephone"
                                                value={responsibleUser?.telephone}
                                                className="mt-1 block w-full"
                                                required={true}
                                                handleChange={handleChangeResponsibleUser}
                                            />
                                            {/* <Error bind={errors.second_name} /> */}
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2 justify-start mt-2">
                                        <Input checked={responsibleForAssistants} id="checkbox-responsible-for-assistants" type="checkbox" handleChange={(event) => setResponsibleForAssistants(event.target.checked)} />
                                        <Label forInput="checkbox-responsible-for-assistants" value="Se hace responsable de todos los asistentes" />
                                    </div>
                                </form>
                            </div>
                            <div className="border rounded-xl p-5  my-5 relative">

                                <h2 className="absolute bg-white px-2 font-bold" style={{top:'-13px'}}>Datos de los asistentes</h2>
                                <Form
                                    onAction={handleAction}
                                    onSubmit={submit}
                                    users={usersRegistration}
                                    ticketsQuantity={quantity}
                                    processing={processing}
                                    onInputChange={handleChangeUsersRegistration}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <pre><code>{JSON.stringify(users,null,4)}</code></pre> */}
                </div>

            </div>
        </>
    );
}
